import type {CSSProperties} from 'react';
import {wedgeExactRole} from './wedgeRoles.js';

export type WedgeProfileBottomLook = 'youb-search-clear';

export const isWedgeProfileBottomLook = (look: string | undefined): look is WedgeProfileBottomLook => look !== undefined && look.startsWith('youb-');

/* Released settings search bar on You (bottom half of Profile): the Clear search control at the end of the bar. It is a bare inline-flex box
   around a 14px glyph, 4px of padding on every side, with no fill and no border, in the tertiary label ink and the pointer. It keeps the
   declaration order of the source so the shipped ink rules keep matching the serialized text. It draws no transparent target and no anchor
   (`wedgeSettingsDrawsHit`, and a `content: none` rule naming the prefix): the bar is 44px tall and the box sits inside it, so a grown
   region would only repeat the bar. */
export function wedgeProfileBottomStyle(_look: WedgeProfileBottomLook): CSSProperties {
  const r = wedgeExactRole;
  return {
    background: 'transparent', border: 0, cursor: 'pointer', color: r('labelTer'),
    display: 'inline-flex', alignItems: 'center', padding: 4, flexShrink: 0,
  };
}
